
// Importa las librerías necesarias para la aplicación
import React from 'react'; // Importa React, necesario para usar JSX y trabajar con componentes en React
import ReactDOM from 'react-dom/client'; // Importa ReactDOM para interactuar con el DOM del navegador y renderizar la aplicación
import App from './App'; // Importa el componente principal 'App', que contiene toda la lógica y los componentes de la aplicación

// Obtiene el contenedor HTML con el id 'root' donde se montará la aplicación React
const root = ReactDOM.createRoot(document.getElementById('root')); // Crea un root de React en el contenedor HTML con el id 'root'

// Renderiza el componente 'App' dentro del contenedor 'root' en el DOM, esto inicializa la aplicación
root.render(<App />); // Monta el componente principal 'App' dentro del DOM, es el punto de entrada de la aplicación React

